<template>
  <div class="more-loading">
    <div class="more-loading-content" ref="moreLoading"></div>
  </div>
</template>
<script>
import lottie from 'lottie-web'
export default {
  name: 'more-loading',
  mounted () {
    lottie.loadAnimation({
      container: this.$refs.moreLoading,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: 'https://s.kcimg.cn/wap/font/lottie/more-loading.json' // 动画json的路径
    })
  }
}
</script>
<style scoped>
.more-loading{
  height: 30px;
  line-height: 30px;
}
.more-loading-content{
  height: 15px;
}
</style>
